import {
    EMAIL_UNSUBSCRIBE_CONFIRM_ERROR,
    EMAIL_UNSUBSCRIBE_CONFIRM_START,
    EMAIL_UNSUBSCRIBE_CONFIRM_SUCCESS,
    EMAIL_UNSUBSCRIBE_FETCH_INVALID,
    EMAIL_UNSUBSCRIBE_FETCH_START,
    EMAIL_UNSUBSCRIBE_FETCH_SUCCESS,
    EmailUnsubscribeAction
} from 'actions/emailUnsubscribe/EmailUnsubscribeActionTypes';

import { EmailUnsubscribeState } from './EmailUnsubscribeState';

const initialState: EmailUnsubscribeState = {
    email: null,
    marketplaceName: null,
    alreadyOptedOut: false,
    justConfirmed: false,
    loading: false,
    confirming: false,
    invalid: false
};

export const emailUnsubscribeReducer = (
    state = initialState,
    action: EmailUnsubscribeAction
): EmailUnsubscribeState => {
    switch (action.type) {
        case EMAIL_UNSUBSCRIBE_FETCH_START:
            // Fresh fetch — clear any previous invalid flag so retries (via
            // component remount on token change) don't render a stale error.
            return { ...initialState, loading: true };

        case EMAIL_UNSUBSCRIBE_FETCH_SUCCESS:
            return {
                ...state,
                loading: false,
                invalid: false,
                email: action.payload.email,
                marketplaceName: action.payload.marketplaceName,
                alreadyOptedOut: action.payload.alreadyOptedOut
            };

        case EMAIL_UNSUBSCRIBE_FETCH_INVALID:
            return { ...initialState, invalid: true };

        case EMAIL_UNSUBSCRIBE_CONFIRM_START:
            return { ...state, confirming: true };

        case EMAIL_UNSUBSCRIBE_CONFIRM_SUCCESS:
            return { ...state, confirming: false, justConfirmed: true };

        case EMAIL_UNSUBSCRIBE_CONFIRM_ERROR:
            // Roll back to pre-confirm — the terminal card doesn't render,
            // Confirm button reappears so the user can retry.
            return { ...state, confirming: false };

        default:
            return state;
    }
};

export default emailUnsubscribeReducer;
